<template>
  <v-container fluid class="home-container">
    <v-row justify="center" align="center" class="min-height-screen">
      <v-col cols="12" sm="10" md="8" lg="6" xl="5">
        <div class="main-card-wrapper">
          <!-- Header Card -->
          <v-card class="header-card elevation-8 mb-6" :class="{ 'mobile-header': $vuetify.breakpoint.xs }">
            <div class="header-content">
              <div class="icon-wrapper mb-3">
                <v-icon size="48" color="white">mdi-school</v-icon>
              </div>

              <p class="subtitle-1 text-center white--text opacity-90">Selecione o questionário que deseja responder</p>
            </div>
          </v-card>

          <!-- Questionários List -->
          <div class="questionarios-container">
            <v-card
              v-for="(item, index) in param.listQuestionario"
              :key="item.id"
              class="questionario-card elevation-4 mb-4"
              :class="{ 'mobile-card': $vuetify.breakpoint.xs }"
              @click="selectQuestionario(item)"
              :style="{ 'animation-delay': `${index * 0.1}s` }"
            >
              <v-card-text class="d-flex align-center pa-4">
                <div class="icon-container">
                  <v-icon size="24" color="success">mdi-check-circle</v-icon>
                </div>
                <div class="content-container flex-grow-1">
                  <h3 class="questionario-title">{{ item.instrumento }}</h3>
                  <h3 class="questionario-title">{{ item.anexo }}</h3>
                  <small class="questionario-code">Código: {{ item.id }}</small>
                </div>
                <div class="arrow-container">
                  <v-icon color="primary">mdi-chevron-right</v-icon>
                </div>
              </v-card-text>
            </v-card>
          </div>

          <!-- Loading State -->
          <v-card v-if="loading" class="loading-card elevation-4">
            <v-card-text class="text-center pa-8">
              <v-progress-circular indeterminate color="primary" size="64" class="mb-4"></v-progress-circular>
              <p class="subtitle-1 grey--text">Carregando questionários...</p>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
    </v-row>

    <!-- Dialog seleção de instituição -->
    <v-dialog v-model="dialogInstituicao" max-width="500" persistent>
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon color="white" class="mr-2">mdi-domain</v-icon>
          Selecione a Instituição
        </v-card-title>
        <v-card-text class="pa-4">
          <p class="body-2 grey--text text--darken-1 mb-3">
            Você está vinculado a mais de uma instituição. Escolha para qual deseja responder:
          </p>
          <v-list>
            <v-list-item
              v-for="inst in listaInstituicoes"
              :key="inst.id_instituicao"
              @click="confirmarInstituicao(inst)"
              class="inst-item mb-2"
            >
              <v-list-item-icon>
                <v-icon :color="inst.respondido ? 'grey' : 'primary'">
                  {{ inst.respondido ? "mdi-check-circle" : "mdi-domain" }}
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title :class="inst.respondido ? 'grey--text' : ''">{{
                  inst.instituicao
                }}</v-list-item-title>
                <v-list-item-subtitle v-if="inst.respondido" class="grey--text"
                  >Questionário já respondido</v-list-item-subtitle
                >
              </v-list-item-content>
              <v-list-item-action>
                <v-icon color="grey">mdi-chevron-right</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogInstituicao = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
//import QuestionariosServices from "@/services/ava/QuestionariosServices";
import AvaliacaoInstitucionalServices from "@/services/avaliacaoInstitucional/AvaliacaoInstitucionalServices";
import ServidorServices from "@/services/rh/ServidorServices";
import { Libs } from "@/libs/libs";
export default {
  name: "HomeAvaliacao",
  data: () => ({
    selectedItem: 1,
    loading: false,
    dialogInstituicao: false,
    listaInstituicoes: [],
  }),
  components: {},
  filters: {},
  computed: {
    ...mapGetters({ param: "avaliacao/param" }),
  },
  methods: {
    ...mapActions({
      requestQuestionarios: "avaliacao/requestQuestionarios",
      requestValidar: "avaliacao/requestValidar",
    }),

    async selectQuestionario(item) {
      this.param.Selecionado = item;
      const pkpessoa = Libs.getPayloadToken("pkpessoa");
      const pessoa = await ServidorServices.getServidor({ pkpessoa });

      const payload = { cpf: pessoa.cpf, cgm: null, id_questionario: item.id, id_processo: item.id_processo };
      const { data: resposta } = await this.requestValidar(payload);
      const lista = resposta?.data || [];

      if (lista.length === 0) {
        this.$toast.error("Nenhuma instituição disponível para este questionário.");
        return;
      }

      if (lista.length === 1) {
        this.confirmarInstituicao(lista[0]);
      } else {
        this.listaInstituicoes = lista;
        this.dialogInstituicao = true;
      }
    },
    confirmarInstituicao(inst) {
      if (inst.respondido) {
        this.$toast.warning(`Você já respondeu o questionário para ${inst.instituicao}.`);
        return;
      }
      this.$store.commit("avaliacao/setPessoa", inst);
      this.dialogInstituicao = false;
      this.$router.push({ name: "questionario" });
    },
    async loadQuestionario() {
      try {
        this.loading = true;
        // const ano = new Date().getFullYear();

        const data = await AvaliacaoInstitucionalServices.questiuonariosServidoresAvaliacao();
        console.log("o retorno.....", data);
        this.param.listQuestionario = data;
        this.loading = false;
      } catch (error) {
        console.error("Erro ao carregar questionários:", error);
        this.param.listQuestionario = [];
      }
    },
  },
  mounted: function () {
    this.loadQuestionario();
  },
};
</script>

<style scoped>
.home-container {
  background: linear-gradient(135deg, #f5f5f5 0%, #efebe9 100%);
  min-height: 100vh;
  padding: 24px 16px;
}

.min-height-screen {
  min-height: calc(100vh - 48px);
}

.main-card-wrapper {
  animation: fadeInUp 0.8s ease-out;
}

.header-card {
  background: #2196f3;
  border-radius: 16px !important;
  overflow: hidden;
  position: relative;
}

.header-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

.header-content {
  position: relative;
  z-index: 1;
  padding: 32px 24px;
  text-align: center;
}

.icon-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  backdrop-filter: blur(10px);
}

.questionarios-container {
  animation: fadeInUp 1s ease-out 0.3s both;
}

.questionario-card {
  border-radius: 12px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  cursor: pointer;
  border: 2px solid transparent;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  animation: slideInLeft 0.6s ease-out both;
}

.questionario-card:hover {
  transform: translateY(-4px) scale(1.02);
  box-shadow: 0 12px 40px rgba(102, 126, 234, 0.3) !important;
  border-color: #667eea;
}

.icon-container {
  background: linear-gradient(135deg, #4caf50, #45a049);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
}

.content-container {
  margin-left: 8px;
}

.questionario-title {
  color: #2c3e50;
  font-weight: 600;
  font-size: 1.1rem;
  margin-bottom: 4px;
  line-height: 1.3;
}

.questionario-code {
  color: #7c4dff;
  font-weight: 500;
  font-size: 0.85rem;
  opacity: 0.8;
}

.arrow-container {
  transition: transform 0.3s ease;
}

.questionario-card:hover .arrow-container {
  transform: translateX(4px);
}

.loading-card {
  border-radius: 12px !important;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
}

/* Mobile Responsive */
.mobile-header .header-content {
  padding: 24px 16px;
}

.mobile-header .display-1 {
  font-size: 1.5rem !important;
}

.mobile-card {
  margin-bottom: 12px !important;
}

.mobile-card .v-card__text {
  padding: 16px !important;
}

.mobile-card .questionario-title {
  font-size: 1rem;
}

/* Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Breakpoint Adjustments */
@media (max-width: 599px) {
  .home-container {
    padding: 16px 8px;
  }

  .questionario-title {
    font-size: 0.95rem;
  }

  .icon-container {
    width: 36px;
    height: 36px;
    margin-right: 12px;
  }

  .icon-wrapper {
    width: 64px;
    height: 64px;
  }
}

@media (max-width: 959px) and (min-width: 600px) {
  .header-content {
    padding: 28px 20px;
  }
}

@media (min-width: 1264px) {
  .questionario-card {
    margin-bottom: 20px !important;
  }

  .header-content {
    padding: 40px 32px;
  }
}
</style>
